import typography from "../../base/typography";
import colors from "../../base/colors";
/** Shared pill-shaped action styling, including keyboard and disabled states. */
export default {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "0.4rem",
  fontSize: typography.size.sm,
  fontWeight: 600,
  borderRadius: "999px",
  padding: "10px 18px",
  lineHeight: 1.5,
  textAlign: "center",
  textTransform: "none",
  userSelect: "none",
  transition: "background-color 150ms ease, border-color 150ms ease, transform 150ms ease",
  "&:active": { transform: "translateY(1px)" },
  "&.Mui-focusVisible": { outline: "3px solid " + colors.brand.ink, outlineOffset: 3 },
  "&:disabled": { opacity: 0.4 },
  "& .material-icons": { fontSize: "1rem" },
};
